
<div id="newsletter">
  <!-- Modale newsletter -->
  <b-modal
    id="modale-newsletter"
    modal-class="modale-newsletter-class"
    content-class="modal-content-newsletter-info"
    body-class="modal-body-newsletter py-0"
    centered
    no-fade
    no-hide-backdrop
    no-close-on-backdrop
    no-close-on-esc
    modal-footer
  >
    <template #modal-header="{ close }">
      <div v-if="content.titre" class="row posBtnFermer">
        <button class="btnClose" @click="close()">
          <svg-icon
            icon-name="icone-fermer-mince"
            color="$couleur-primaire"
            className="iconeFermer"
          ></svg-icon>
        </button>
      </div>
      <h2 class="texte-noir text-center pt-3 mb-0" v-html="content.titre"></h2>
    </template>
    <div>
      <div class="graphik_medium body-3 texte-noir text-center mx-2 mb-0">
        <span class="d-flex" v-html="content.message" />
      </div>
    </div>
    <div class="col-12 graphik_regular caption-3 texte-noir text-left px-2 my-0 py-0">
      <b-form-checkbox
        id="subscribe-newsletter"
        v-model="subscribeNewsletter"
        name="subscribe-newsletter"
        class="mb-n2"
        ><span v-html="content.accepterRecevoirMessage" />
      </b-form-checkbox>
    </div>
    <MessageMel
      v-show="message"
      :content="messageErreur"
      class="graphik_medium pl-2 mt-n2 mb-1 mb-md-0 py-0"
    >
    </MessageMel>

    <template #modal-footer>
      <div class="row col-12 justify-content-center my-0">
        <b-button
          class="btn-primaire w-xs-auto w-md-auto px-3"
          variant="modal"
          data-dismiss="modal"
          @click="souscrireNewsletter()"
        >
          {{ content.texteBtnContinuer }}
        </b-button>
      </div>
      <div class="row col-12 justify-content-center pt-1">
        <b-link
          class="caption-2 lien-annuler"
          variant="modal"
          data-dismiss="modal"
          @click="fermerModaleNewsletter()"
        >
          {{ content.texteAnnuler }}
        </b-link>
      </div>
    </template>
  </b-modal>
  <ModaleConfirmation
    :content="contentModaleConfirmation"
    @close="fermerModaleNewsletterConfirmation()"
  />
  <ModaleConfirmation :content="contentModaleErreur" @close="fermerModaleNewsletterErreur()" />
</div>
